import { metricsDimensionTabs } from '@/metrics/constants'

import { countriesDescriptions, orderColumns, productColumns, productColumnsWithoutSalesData } from './constants'

export const getCountriesColumns = (selectedTab, salesOrdersDataActivated) => {
  if (!salesOrdersDataActivated) return productColumnsWithoutSalesData
  if (selectedTab === metricsDimensionTabs.order) return orderColumns

  return productColumns
}

export const getCountriesDescription = (selectedTab, salesOrdersDataActivated) => {
  if (!salesOrdersDataActivated) return countriesDescriptions.withoutSalesData
  if (selectedTab === metricsDimensionTabs.order) return countriesDescriptions.order

  return countriesDescriptions.product
}
